import React from 'react';

import { 
  ARMOR_TYPE_OPTIONS,
  ArmorType
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props {
  name: string;
  value?: string;
  multiple?: boolean;
  values?: string[];
  armor_types?: ArmorType[] | null;
  allow_all?: boolean;
  allow_none?: boolean;
  allow_any?: boolean;
  onChange: Function;
  disabled?: boolean;
}

const SelectArmorTypeBox = ({
  name,
  value,
  multiple = false,
  values = [],
  allow_all = false,
  allow_none = false,
  allow_any = false,
  onChange,
  disabled = false
}: Props) => {
  const extra_options: string[] = [];
  if (allow_all) extra_options.push("All");
  if (allow_none) {
    extra_options.push("None");
    extra_options.push("Shield Only");
  }
  if (allow_any) extra_options.push("Any");

  if (multiple) {
    return (
      <SelectStringBox
        options={ARMOR_TYPE_OPTIONS}
        multiple
        extra_options={extra_options}
        values={values}
        name={name}
        disabled={disabled}
        onChange={(ids: string[]) => onChange(ids)}
      />
    );
  }

  return (
    <SelectStringBox
      options={ARMOR_TYPE_OPTIONS}
      value={value}
      name={name}
      extra_options={extra_options}
      disabled={disabled}
      onChange={(id: string) => onChange(id)}
    />
  );
};

export default SelectArmorTypeBox;